export default __webpack_public_path__ + "static/media/generate-pixilate.c851395a.png";